import React, {ReactElement} from "react";

export interface ProgressBarProps {
    fillPercent: number
}

export function ProgressBar(props: ProgressBarProps): ReactElement {
    return (
        <div className="h-full w-full bg-gray-3 rounded-full overflow-hidden relative">
            <div className="absolute left-[-2px] h-full bg-secondary transform skew-x-[-45deg]"
                 style={{width: `${props.fillPercent}%`}}
            >
            </div>
        </div>
    );
}